import { cloneDeep } from "lodash";
import initialState from "../../store/initialState";
import { TOWER_EDIT_MODE_CHANGED } from "../../constants/actionTypes";

export default function towerEditStatusReducer(state = initialState.towerEditStatus, action) { 
  switch (action.type) {
    case TOWER_EDIT_MODE_CHANGED: {
        let newState = cloneDeep(state);
        newState.isEditing = action.isEditing;
        newState.towerId = action.towerId;
        return newState;
    }

    default:
      return state;
  }
};